export const dashboardIt: Record<string, string> = {
  'good_morning': 'Buongiorno',
  'good_afternoon': 'Buon pomeriggio',
  'good_evening': 'Buonasera',
  'there': 'cara',
  'welcome_to_bridal_dashboard': 'Benvenuta nella tua dashboard nuziale',
  'new_appointment': 'Nuovo Appuntamento',
  'total_leads': 'Contatti Totali',
  'customers': 'Clienti',
  'total_in_pipeline': 'Totale in pipeline',
  'registered_customers': 'Clienti registrati',
  'subtotal': 'Subtotale',
  'tailoring_cost': 'Costo Sartoria',
  'next_7_days': 'Prossimi 7 giorni',
  'active_orders': 'Ordini Attivi',
  'in_progress': 'In corso',
  'dashboard_total_revenue': 'Ricavo Totale',
  'dashboard_unrequested_amount': 'Non Richiesto',
  'dashboard_unpaid_balance': 'Saldo Non Pagato',
  'dashboard_across_all_orders': 'Su tutti gli ordini',
  'dashboard_outstanding_payments': 'Pagamenti in sospeso',
  'dashboard_not_covered_by_requests': 'Non coperto da richieste',
  'recent_leads': 'Contatti Recenti',
  'latest_inquiries_from_potential_customers': 'Ultime richieste da potenziali clienti',
  'view_all': 'Vedi Tutto',
  'no_stage': 'Nessuna Fase',
  'no_recent_leads': 'Nessun contatto recente',
  'todays_and_upcoming_scheduled_appointments': 'Appuntamenti di oggi e prossimi programmati',
  'no_upcoming_appointments': 'Nessun appuntamento in programma',
  'quick_actions': 'Azioni Rapide',
  'common_tasks_to_get_started': 'Attività comuni per iniziare',
  'add_lead': 'Aggiungi Contatto',
  'new_customer': 'Nuovo Cliente',
  'schedule_fitting': 'Programma Prova',
  'create_order': 'Crea Ordine',
  'recent_activity': 'Attività Recente',
  'no_recent_activity': 'Nessuna attività recente',
  'book_appointment': 'Prenota Appuntamento',
  'view_wishlist': 'Vedi Lista Desideri',
  'view_orders': 'Vedi Ordini',
  'contact_us': 'Contattaci',
  'share_qr_code': 'Condividi il tuo codice come QR',
  'wedding_countdown': 'Conto alla Rovescia del Matrimonio',
  'days_until_wedding': 'giorni fino al tuo giorno speciale',
  'hours_until_wedding': 'ore fino al tuo giorno speciale',
  'minutes_until_wedding': 'minuti fino al tuo giorno speciale',
  'wedding_passed': 'Il tuo giorno speciale è passato',
  'order_status': 'Stato Ordine',
  'track_progress': 'Traccia il progresso del tuo abito',
  'earn_points': 'Guadagna punti e ricompense speciali',
  'guides_tips': 'Guide e consigli per la pianificazione del matrimonio',
  'latest_interactions': 'Le tue ultime interazioni con noi',
  'visit_boutique': 'Visita il nostro negozio per assistenza personalizzata',
  'get_in_touch': 'Mettiti in contatto con il nostro team',
  'dream_dress_journey': 'Il viaggio del tuo abito da sogno continua qui',
  'congratulations_wedding': 'Congratulazioni per il tuo giorno del matrimonio!',
  'view_manage_fittings': 'Visualizza e gestisci le tue prossime prove',
  'favorite_dresses': 'I tuoi abiti preferiti e ispirazione',
  'dashboard.featureComingSoon': 'Questa funzionalità sarà disponibile presto!',
};
